// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip.p-info-tooltip,\n.p-info-tooltip {\n  max-width: 360px !important;\n  z-index: 2000 !important;\n}\n.p-info-tooltip .tooltip-inner {\n  max-width: 360px !important;\n  text-align: left !important;\n  white-space: normal !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
